export default "__VITE_ASSET__DPVnvngq__"